import {
    ChartIQRangePeriodicityController,
    tfIqPeriod
} from "../../../../../components/chartiq/components/chart-periodicity/ChartIQPeriodicityComponent";
import {InterDayPeriods} from "../../../../../components/chartiq/components/chart-periodicity/Periods";
import {ObjectUtil} from "../../../../../js/util/ObjectUtil";

export const SimulationChartPeriod = "tfSimulationChartPeriod";

export function simulationChartPeriod() {
    return ObjectUtil.merge({}, tfIqPeriod(), { controller: SimulationChartPeriodSelectorController });
}

export class SimulationChartPeriodSelectorController extends ChartIQRangePeriodicityController {
    public periods = InterDayPeriods;
}
